import { Visibility, VisibilityOff } from '@mui/icons-material';
import { IconButton, InputAdornment, TextField } from '@mui/material';
import React, { Component } from 'react';

interface PasswordFieldProps {
  label: string;
  name: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

interface PasswordFieldState {
  showPassword: boolean;
}

class PasswordField extends Component<PasswordFieldProps, PasswordFieldState> {
  state: PasswordFieldState = {
    showPassword: false,
  };

  togglePasswordVisibility = () => {
    this.setState((prevState) => ({ showPassword: !prevState.showPassword }));
  };

  render() {
    const { label, name, onChange } = this.props;
    const { showPassword } = this.state;

    return (
      <TextField
        className="react-PasswordField"
        label={label}
        name={name}
        type={showPassword ? 'text' : 'password'}
        fullWidth
        required
        onChange={onChange}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <IconButton onClick={this.togglePasswordVisibility}>
                {showPassword ? <VisibilityOff /> : <Visibility />}
              </IconButton>
            </InputAdornment>
          ),
        }}
      />
    );
  }
}

export default PasswordField;
